<template>
    <div class="mx-auto flex-1 min-h-0 overflow-y-auto w-full overflow-x-hidden">
        <a id="cz3__step-options--scroll-to-target" class="block -mt-16 pt-16"></a>

        <step-options-buttons
            v-if="groupType === 'buttons'"
            :item-data="itemData"
            @applySelections="handleApplySelections"
        />

        <step-options-wedges
            v-if="groupType === 'wedge'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-front
            v-if="groupType === 'front'"
            :item-data="itemData"
            :is-dirty="effectiveIsDirty"
            @noCustomization="frontNoCustomizationSelected = $event"
            @applySelections="handleApplySelections"
        />

        <step-options-stamps
            v-if="groupType === 'stamps'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-paintfill
            v-if="groupType === 'paintfill'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-top
            v-if="groupType === 'top'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-laser-etching
            v-if="groupType === 'laseretching'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-grip
            v-if="groupType === 'grip'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-shaft-band
            v-if="groupType === 'shaftband'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-shaft
            v-if="groupType === 'shaft'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-initials
            v-if="groupType === 'initials'"
            :is-dirty="isDirty"
            :item-data="itemData"
            @applySelections="handleApplySelections"
        />

        <step-options-back
            v-if="groupType === 'back'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-headcover
            v-if="groupType === 'headcover'"
            :item-data="itemData"
            :is-dirty="isDirty"
            @applySelections="handleApplySelections"
        />

        <step-options-summary
            v-if="shouldShowSummary"
        />
    </div>

    <step-options-apply-selections
        v-if="!shouldShowSummary"
        :is-disabled="inErrorState || !isComplete"
        :is-dirty="effectiveIsDirty"
        :should-show-paintfill-requirement="false"
        :should-show-generic-requirement="shouldShowGenericRequirement"
        @applySelections="handleApplySelections"
        @handleDisabled="handleDisabled"
    />

    <div v-if="shouldShowSummary"
        :class="[
            'border-t border-gray-DFDFDF flex justify-center p-4 px-[12px] lg:px-[40px] bg-white gap-4 bottom-0 w-full h-[90px] max-h-[90px]'
        ]">
        <save-and-exit-button />
        <continue-button
            v-if="saveButtonMode === 'default' || !saveButtonMode"
            :isDisabled="inErrorState"
            @goNext="slideProgress++"
        />
    </div>
</template>

<script>
    import StepOptionsStamps from './StepOptionsStamps.vue';
    import StepOptionsButtons from './buttons/StepOptionsButtons.vue';
    import StepOptionsWedges from './StepOptionsWedges.vue';
    import StepOptionsPaintfill from './StepOptionsPaintfill.vue';
    import StepOptionsLaserEtching from './StepOptionsLaserEtching.vue';
    import StepOptionsInitials from './StepOptionsInitials.vue';
    import StepOptionsFront from './StepOptionsFront.vue';
    import StepOptionsGrip from './StepOptionsGrip.vue';
    import StepOptionsSummary from './StepOptionsSummary.vue';
    import StepOptionsShaft from './StepOptionsShaft.vue';
    import StepOptionsShaftBand from './StepOptionsShaftBand.vue';
    import StepOptionsApplySelections from './StepOptionsApplySelections.vue';
    import SaveAndExitButton from './buttons/SaveAndExitButton.vue';
    import ContinueButton from './buttons/ContinueButton.vue';
    import StepOptionsTop from './StepOptionsTop.vue';
    import StepOptionsBack from './StepOptionsBack.vue';
    import StepOptionsHeadcover from './StepOptionsHeadcover.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        emits: ['applySelections'],

        components: {
            StepOptionsGrip,
            StepOptionsButtons,
            StepOptionsWedges,
            StepOptionsPaintfill,
            StepOptionsLaserEtching,
            StepOptionsInitials,
            StepOptionsSummary,
            StepOptionsShaft,
            StepOptionsShaftBand,
            StepOptionsStamps,
            StepOptionsFront,
            StepOptionsApplySelections,
            SaveAndExitButton,
            ContinueButton,
            StepOptionsTop,
            StepOptionsBack,
            StepOptionsHeadcover,
        },

        props: {
            itemData: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                isDirty: false,
                frontNoCustomizationSelected: false,
            };
        },

        computed: {
            // shouldShowPaintfillRequirement() {
            //     if (this.groupType === 'front') {
            //         return this.customizerStore.isFrontSectionActive('paintfill')
            //             && !this.customizerStore.isPaintfillComplete('Face/Sole');
            //     }

            //     if (this.groupType === 'top') {
            //         return this.customizerStore.isTopSectionActive()
            //             && !this.customizerStore.isPaintfillComplete('Top');
            //     }

            //     if (this.groupType === 'back') {
            //         return this.customizerStore.isBackSectionActive()
            //             && !this.customizerStore.isPaintfillComplete('Back');
            //     }

            //     return false;
            // },

            saveButtonMode() {
                return this.customizerStore.options.saveButtonMode;
            },

            shouldShowGenericRequirement() {
                return this.groupType === 'front' && (!this.isComplete || this.inErrorState);
            },

            effectiveIsDirty() {
                return this.isDirty || this.hasFaceSoleValidationAttempted;
            },

            hasFaceSoleValidationAttempted() {
                if (this.groupType !== 'front') {
                    return false;
                }

                return ['initials', 'stamps', 'paintfill']
                    .some((section) => this.customizerStore.hasFrontNestedPanelValidationAttempted(section));
            },

            isComplete() {
                // Front: complete if
                // - Stamps selected (non-placeholder, not blank), OR
                // - Initials selected (non-placeholder) AND required text fields are filled AND no profanity error.
                if (this.groupType === 'front') {
                    if (this.frontNoCustomizationSelected) {
                        return true;
                    }
                    const vc = this.customizerStore.viewController;
                    const initials = vc?.selectedAtPlacement('StampingStyle');
                    const stamps = vc?.selectedAtPlacement('Stamp');
                    const paintfill = vc?.selectedAtPlacement('PutterFrontPaintfill');

                    const hasInitials = !!(initials && !initials.placeholder);
                    const hasStamps = !!(stamps && !stamps.placeholder && stamps.code !== 'Stamp-Stamp-Blank');
                    const hasPaintfill = paintfill != null && !paintfill.placeholder;
                    const hasInitialsColor = this.customizerStore.uiStepSubOptions?.frontInitials
                        ?.some((option) => !!option.selectedColor);
                    const hasStampsColor = this.customizerStore.uiStepSubOptions?.frontStamps
                        ?.some((option) => !!option.selectedColor);

                    // If initials selected and profanity flagged, block completion (even if stamps selected)
                    const panelErrors = this.customizerStore.panelsInErrorState ?? [];
                    const currentGroup = this.customizerStore.currentGroup;
                    const hasProfanityError = panelErrors.includes(`${currentGroup}-v-stamping-text-1`)
                        || panelErrors.includes(`${currentGroup}-v-stamping-text-2`);

                    if (hasInitials && hasProfanityError) {
                        return false;
                    }

                    if (hasPaintfill && !this.customizerStore.isPaintfillComplete('Face/Sole')) {
                        return false;
                    }

                    if (hasStamps) {
                        return hasStampsColor;
                    }

                    if (hasInitials) {
                        const requiresText1 = initials?.custom?.['v-stamping-has-text-1'] === 'yes';
                        const text1Value = initials?.custom?.['v-stamping-text-1'];
                        const requiresText2 = initials?.custom?.['v-stamping-has-text-2'] === 'yes';
                        const text2Value = initials?.custom?.['v-stamping-text-2'];

                        if (!hasInitialsColor) {
                            return false;
                        }

                        const text1Ok = !requiresText1 || (text1Value != null && `${text1Value}`.length > 0);
                        const text2Ok = !requiresText2 || (text2Value != null && `${text2Value}`.length > 0);

                        return text1Ok && text2Ok;
                    }

                    if (hasPaintfill) {
                        return this.customizerStore.isPaintfillComplete('Face/Sole');
                    }

                    return false;
                }

                if (this.groupType === 'top') {
                    if (this.customizerStore.isTopNoCustomizationSelected()) {
                        return true;
                    }

                    const vc = this.customizerStore.viewController;

                    const paintfill = vc?.selectedAtPlacement('PutterTopPaintfill');
                    const hasPaintfill = paintfill != null && !paintfill.placeholder;

                    if (hasPaintfill) {
                        return this.customizerStore.isPaintfillComplete('Top');
                    }

                    return false;
                }

                if (this.groupType === 'back') {
                    if (this.customizerStore.isBackNoCustomizationSelected()) {
                        return true;
                    }

                    const vc = this.customizerStore.viewController;

                    const paintfill = vc?.selectedAtPlacement('PutterBackPaintfill');
                    const hasPaintfill = paintfill != null && !paintfill.placeholder;

                    if (hasPaintfill) {
                        return this.customizerStore.isPaintfillComplete('Back');
                    }

                    return false;
                }

                // otherwise, validate the selection has been made
                return this.customizerStore.selectionsMade?.includes(this.currentGroup);
            },

            panelToReset() {
                return this.customizerStore.panelToReset;
            },

            inErrorState() {
                // If there is a group selected and open, only check the error state for the group.
                // Otherwise if there are multiple groups triggering the validation state,
                // We'll never be able to get out of a group.
                if (this.currentGroup != null && this.appStore.showGroupOverlay) {
                    return this.customizerStore.panelsInErrorState.some((x) => x.startsWith(this.currentGroup));
                }

                // Otherwise check all panels.
                return this.customizerStore.panelsInErrorState.length > 0;
            },

            shouldShowSummary() {
                return this.appStore.shouldShowSummary;
            },

            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            groupType() {
                if (this.shouldShowSummary) {
                    return 'summary';
                }

                const groupType = this.itemData.custom?.['v-group-type'];

                return groupType;
            },
        },

        watch: {
            async panelToReset() {
                this.isDirty = false;
            },

            currentGroup() {
                this.isDirty = false;
            },
        },

        methods: {
            scrollToTop() {
                this.appStore.scrollPanelToTop();
            },

            handleApplySelections() {
                this.isDirty = true;

                this.$emit('applySelections');
            },

            handleDisabled() {
                if (this.groupType === 'front') {
                    ['initials', 'stamps', 'paintfill'].forEach((section) => {
                        this.customizerStore.setFrontNestedPanelValidationAttempted(section, true);
                    });
                }

                this.handleApplySelections(true);
            },
        },
    };
</script>

<style>
    #cz3 {
        overflow-y: clip
    }
</style>
